import { useCallback } from 'react';

export const useTextMeasurement = () => {
  const measureTextWidth = useCallback(
    (text: string, fontSize = '0.75rem', fontFamily = 'Avenir, Arial, sans-serif'): number => {
      // Create a temporary canvas element for text measurement
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      if (!context) return text.length * 8; // Fallback calculation

      const fontSizeInPx = fontSize.includes('rem') ? parseFloat(fontSize) * 16 : parseFloat(fontSize);
      context.font = `${fontSizeInPx}px ${fontFamily}`;
      return context.measureText(text).width;
    },
    [],
  );

  return { measureTextWidth };
};
